<script>
    import _ from 'lodash'

    export default {
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            execute: {
                type: Function,
                required: true
            },
            exclude: {
                type: Array,
                default: () => []
            }
        },
        mounted () {
            const listener = (e) => {
                if (!this.isActive) return

                if (e.target === this.$el || this.$el.contains(e.target)) {
                    return
                }

                if (this.exclude) {
                    const els = _.filter(this.exclude, el => _.isElement(el))

                    for (let i = 0; i < els.length; i++) {
                        if (els[i] && (e.target === els[i] || els[i].contains(e.target))) {
                            return
                        }
                    }

                    const selectors = _.filter(this.exclude, str => _.isString(str))

                    for (let i = 0; i < selectors.length; i++) {
                        const selector = selectors[i].substr(1)

                        var el = e.target

                        while (el) {
                            if (el.classList && el.classList.contains(selector)) {
                                return
                            }

                            el = el.parentNode
                        }
                    }
                }

                this.execute(e.target)
            }

            document.addEventListener('click', listener)

            this.$once('hook:beforeDestroy', () => {
                document.removeEventListener('click', listener)
            })
        },
        render () {
            return this.$slots.default[0]
        }
    }
</script>
